import { render, staticRenderFns } from "./PlayersFilterSubHeader.vue?vue&type=template&id=a67a80f0&scoped=true&"
import script from "./PlayersFilterSubHeader.vue?vue&type=script&lang=js&"
export * from "./PlayersFilterSubHeader.vue?vue&type=script&lang=js&"
import style0 from "./PlayersFilterSubHeader.vue?vue&type=style&index=0&id=a67a80f0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a67a80f0",
  null
  
)

export default component.exports